module.exports = __webpack_public_path__ + "img/avatar.54303a37.svg";